export const notifyMixin = {
  methods: {

    notifyError (error, i18tSection) {

      let message = error.message ? error.message : error
      if (error.response) {
        if ((error.response.status == 404 || error.response.status == 406) && error.response.data.responseStatus) {
          const errorCode = error.response.data.responseStatus.errorCode.replace("Exception", "")
          message = i18tSection ? this.$t(`${i18tSection}.${errorCode}`) : this.$t(errorCode)
        }

      }
      this.$vs.notify({
        title: this.$t('Error'),
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    },
    notifySuccess (message) {
      this.$vs.notify({
        title: this.$t('Success'),
        text: message,
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success'
      })
    }
  }
}